import type { ReactNode } from 'react';
import InfoIcon from '@/shared/assets/info-icon.svg?react';
import { cn } from '@/shared/utils';

type InfoCardProps = {
  title?: string;
  icon?: ReactNode;
  titleClassName?: string;
  children?: ReactNode;
};

export function InfoCard({
  title,
  icon,
  titleClassName,
  children,
}: InfoCardProps) {
  return (
    <div className="flex flex-col gap-[0.8rem] bg-card text-card-foreground flex flex-col gap-6 rounded-4xl px-[1.6rem] py-[1.2rem] shadow-sm text-secondary">
      <div className="flex items-start gap-[1rem]">
        <div className="flex items-center justify-center self-center">
          {icon ?? <InfoIcon className="size-[2.4rem]" />}
        </div>
        {title && (
          <div className={cn('headline5 self-center', titleClassName)}>
            {title}
          </div>
        )}
      </div>
      <div className="p4 text-muted-foreground">{children}</div>
    </div>
  );
}
